import * as salvattore from 'salvattore';

const $masonry = $('.js-masonry');

const masonry = {
  initialize() {
    if (!$masonry.length) {
      return;
    }

    $masonry.attr('data-columns', 'data-columns');
    salvattore.init();
  },
};

export default masonry;
